/* File: src/firebaseConfig.js */

// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';

// Import specific service functions and emulator connectors
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator, httpsCallable } from 'firebase/functions'; // Import Functions emulator connector and callable helper
// import { getStorage, connectStorageEmulator } from 'firebase/storage'; // Uncomment if using Storage emulator
import { getAnalytics, isSupported } from "firebase/analytics"; // Import isSupported for conditional Analytics init

// --- Firebase Project Configuration ---
// IMPORTANT: It's highly recommended to load these values from environment variables
// (e.g., .env files) rather than hardcoding them directly in your source code,
// especially the apiKey.
// Example using environment variables (if using Create React App):
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
//   measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID // Optional
// };
// Remember to add these variables to your .env and .env.production files.

// Using the hardcoded values from your example (replace with your actual config OR use env vars)
const firebaseConfig = {
    apiKey: "AIzaSyAL2q244gxFO83BT-pJrzGy1KaHSjs_Mzk", // Replace with your actual config
    authDomain: "dual-n-back-web-app.firebaseapp.com",
    projectId: "dual-n-back-web-app",
    storageBucket: "dual-n-back-web-app.appspot.com",
    messagingSenderId: "295034730281",
    appId: "1:295034730281:web:0985a41c0105e56fbe6938",
    measurementId: "G-RB23S0812K" // Optional: For Google Analytics

};

// --- Initialize Firebase App ---
const app = initializeApp(firebaseConfig);
console.log("Firebase App Initialized with Project ID:", firebaseConfig.projectId);


// --- Get Service Instances ---
// Initialize service instances regardless of environment. Connection details are handled below.
const auth = getAuth(app);
const db = getFirestore(app);
let functionsInstance = getFunctions(app); // Initialize Functions instance (let allows reassignment for region)
// const storage = getStorage(app); // Uncomment if using Storage


// --- Connect to Emulators in Development Environment ---
// Determine if the app is running in a local development environment
// This check assumes your local dev server runs on localhost or 127.0.0.1
// **** EXPORT THIS FLAG ****
export const isEmulatorEnv = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

if (isEmulatorEnv) {
  console.warn(
    "!! DEVELOPMENT MODE DETECTED !! Connecting to Firebase Emulators. " +
    "Ensure emulators are running (`firebase emulators:start`)."
  );

  try {
    // Point Auth SDK to Auth Emulator
    // Default port: 9099
    // Use 127.0.0.1 instead of localhost if you encounter connection issues in some environments
    connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
    console.log("-> Connected to Auth Emulator (http://127.0.0.1:9099)");

    // Point Firestore SDK to Firestore Emulator
    // Default port: 8080
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
    console.log("-> Connected to Firestore Emulator (http://127.0.0.1:8080)");

    // *** Point Functions SDK to Functions Emulator ***
    // Default port: 5001 (Verify this matches your firebase.json emulators config)
    connectFunctionsEmulator(functionsInstance, "127.0.0.1", 5001);
    console.log("-> Connected to Functions Emulator (http://127.0.0.1:5001)");

    // Point Storage SDK to Storage Emulator (Uncomment if using)
    // Default port: 9199
    // connectStorageEmulator(storage, "127.0.0.1", 9199);
    // console.log("-> Connected to Storage Emulator (http://127.0.0.1:9199)");

    // Note: You don't connect Analytics to an emulator.

  } catch (error) {
     // Log and alert if emulator connection fails
     console.error("!!! CRITICAL ERROR: Failed to connect to Firebase Emulators !!!", error);
     alert(
       "Error connecting to Firebase Emulators. Please ensure they are running " +
       "(`firebase emulators:start`) and check the browser console for details."
     );
  }
} else {
  // --- Production Environment Configuration ---
  console.log("Production environment detected. Using live Firebase services.");

  // Optional: Configure Functions region for production if it's different from the default (us-central1)
  // Example: If your functions are deployed to 'europe-west1'
  // functionsInstance = getFunctions(app, 'europe-west1');
  // console.log("Functions region configured for production:", functionsInstance.region);
}
// --- End Emulator Connection Logic ---


// --- Initialize Analytics (Conditionally) ---
let analytics = null; // Initialize as null

// Check if Analytics is supported in the current browser environment before initializing
isSupported().then((supported) => {
  // Initialize Analytics only if supported AND not in the emulator environment (optional)
  // You might want analytics disabled locally to avoid sending test data.
  if (supported && typeof window !== 'undefined' /* && !isEmulatorEnv */) {
      try {
          analytics = getAnalytics(app);
          console.log("Firebase Analytics initialized.");
      } catch (error) {
          // Catch potential initialization errors (e.g., browser extensions blocking)
          console.warn("Firebase Analytics could not be initialized:", error);
      }
  } else if (isEmulatorEnv) {
       console.log("Firebase Analytics disabled in local emulator environment.");
  } else {
      console.log("Firebase Analytics is not supported in this browser environment.");
  }
}).catch(err => {
    // Catch errors during the support check itself
    console.warn("Error checking Firebase Analytics support:", err);
});


// --- Export Initialized Services ---
// Export the services for use throughout your application.
// Exporting 'functionsInstance' as 'functions' is a common convention.
export {
    app, // Export the app instance if needed elsewhere
    auth,
    db,
    functionsInstance as functions, // Export the potentially emulator-connected Functions instance
    analytics,
    httpsCallable // Export httpsCallable helper for convenience
    // storage // Uncomment if using Storage
};